import { Box, BoxProps } from '@mui/material';

export const ExpandedBox = ({ children, sx, ...rest }: BoxProps) => {
  return (
    <Box
      sx={{
        position: 'absolute',
        inset: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 4,
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Box>
  );
};
